import { useMemo } from 'react';

import type { ApprovalStatus } from '../generated-types';
import { useSigningContext } from '../signingContext/signingContext';

const STATUSES_TO_CHECK: ApprovalStatus[] = ['COMPLETED', 'REJECTED', 'UNKNOWN', 'BIM_EXPIRED'];

const useShowPaymentResult = (error?: boolean): boolean => {
    const { signingStatus, signingOperationPending, signingError, showSigningFlow } = useSigningContext();
    return useMemo(() => {
        return (
            !signingOperationPending &&
            !showSigningFlow &&
            (!!(signingError || error) || (!!signingStatus && STATUSES_TO_CHECK.includes(signingStatus)))
        );
    }, [signingOperationPending, showSigningFlow, signingError, error, signingStatus]);
};

export const useShowTransactionResult = (): boolean => {
    const { signingStatus, signingError } = useSigningContext();
    return useMemo(
        () => !!signingError || (!!signingStatus && STATUSES_TO_CHECK.includes(signingStatus)),
        [signingError, signingStatus],
    );
};

export default useShowPaymentResult;
